"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var SafeRedirect = /** @class */ (function (_super) {
    __extends(SafeRedirect, _super);
    function SafeRedirect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeRedirect.prototype.render = function () {
        return (React.createElement("div", { className: "box-shadow" },
            React.createElement(react_router_1.Redirect, { to: this.props.to }),
            this.props.resources.IfPageDoesNotLoad,
            React.createElement("a", { href: this.props.to },
                " ",
                this.props.resources.ClickHere_LowerCase),
            "."));
    };
    return SafeRedirect;
}(React.Component));
exports.SafeRedirect = SafeRedirect;
//# sourceMappingURL=SafeRedirect.js.map